import React from "react";

import DateTimeUtil from "core/util/DateTimeUtil";

interface IDurationLabelProps {
	value: number;
}

const DurationLabel: React.SFC<IDurationLabelProps> = ({value}) => (
	<span>
		{DateTimeUtil.formatDuration(value)}
	</span>
);

export default DurationLabel;



// WEBPACK FOOTER //
// ./src/core/components/label/DurationLabel.tsx